import { Injectable } from '@angular/core';
import { AuditLogModel, FieldChangeForAuditModel } from './audit.log.response.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { AuditOperations, Dateformat } from '../constants/global.constants';
import { Observable, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthCommonService } from '../Authentication/auth.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { publicIpv4 } from 'public-ip';
import { GeoCountryService } from './geo-country.service';
@Injectable({
  providedIn: 'root'
})

export class AuditLogService {
  readonly _administratorsApiBaseURl:any;
  readonly _commonServiceApiBaseURl?:string="";
  readonly _auditApiBaseURl?:string="";
  auditOperations:any;

  excludeColumnList: string[] = ['CreatedBy','createdBy', 'CreatedDate','createdDate', 'UpdatedBy','updatedBy', 'updatedDate','UpdatedDate','id','Id','localId','suppliersMasterServiceAgreements','ChangeOrderDetails','AddendumDetails','status','Status','ContractInvoiceSentDate', 'ContractInvoiceRaisedDate','ContractInvoiceDueDate','ContractInvoicePaymentDate','ContractInvoiceApprovedDate','ContractDetailId','kpiDataCollection','engagementMasterServiceAgreements','paymentTerm','msaStatus','uploadedMSAFile','supplierContacts','sponsorContacts','kpiStartDateYear','kpiEndDateYear','kpiReportingFrequencyCode','frequencyValueforStartDate','frequencyValueforEndDate','EngagementDataCollectionList'];
  
    constructor(private http: HttpClient, private datepipe: DatePipe, private authService: AuthCommonService, private privilegeService: PrivilegeService, private geoCountryService: GeoCountryService){
    this._administratorsApiBaseURl=environment._administratorsApiBaseURl;
    this._commonServiceApiBaseURl=environment?._commonServiceApiBaseURl;
    this._auditApiBaseURl=environment?._auditApiBaseURl;
    }
 
    _dateformart:any;

    private cachedIpAddress: string = '';

    public async getIPAddress() {
      if (this.cachedIpAddress) {
        return this.cachedIpAddress;
      }
      this.cachedIpAddress = await publicIpv4();
      return this.cachedIpAddress;
    }

  async compareModels(oldModel: any, newModel: any, entityName:string, entityIdentifier:string,operationType:string,fromService:string,contextFields?: { [key: string]: any },fieldDisplayNames?: { [key: string]: string }): Promise<any> {
    this.auditOperations=AuditOperations;
    var listOfAuditLogModel:FieldChangeForAuditModel[]=[];
    var auditLogModel= new FieldChangeForAuditModel();
    var auditModelDetail=new AuditLogModel();
    this._dateformart=Dateformat; 
    var variableToIterate;
    if(Object.keys(newModel).length > 0)
    {
      variableToIterate=newModel;
    }
    else
    {
      variableToIterate=oldModel;
    }
  for (const key in variableToIterate)
   {
    if(oldModel[key] == undefined){
      oldModel[key]=null;
    }
    if(newModel[key] == undefined){
      newModel[key]=null;
    }

    if((oldModel[key] != null && Array.isArray(oldModel[key])) || (newModel[key] != null && Array.isArray(newModel[key]))){
      if (JSON.stringify(oldModel[key]) !== JSON.stringify((newModel[key])) && !this.excludeColumnList.includes(key))  
      {
        auditLogModel= new FieldChangeForAuditModel();
        auditLogModel.fieldName=fieldDisplayNames?.[key] ?? key;
        auditLogModel.oldValue=oldModel[key];
        auditLogModel.newValue=newModel[key];
        listOfAuditLogModel.push(auditLogModel);
       
      }
    }
else//it is not the array field
{
  if(!(oldModel[key] == null && newModel[key] == ""))
  {
    if (oldModel[key] !== newModel[key] && !this.excludeColumnList.includes(key))  
    {
      auditLogModel= new FieldChangeForAuditModel();
      auditLogModel.fieldName=fieldDisplayNames?.[key] ?? key;
      auditLogModel.oldValue=oldModel[key];
      auditLogModel.newValue=newModel[key];
      listOfAuditLogModel.push(auditLogModel);
     
    }
  }
  }
  }

  //return listOfAuditLogModel;
 //Create Audit Model
 if(listOfAuditLogModel.length>0){
 //Prepend context fields (e.g. parent Sponsor/Product) so the audit entry identifies the record
 if(contextFields){
   const contextList=Object.keys(contextFields).map(key=>{
     const contextModel=new FieldChangeForAuditModel();
     contextModel.fieldName=key;
     contextModel.oldValue=contextFields[key];
     contextModel.newValue=contextFields[key];
     return contextModel;
   });
   listOfAuditLogModel.unshift(...contextList);
 }

 auditModelDetail.operationType=operationType;
 //We need to get last identifier value from common service then we will add 1 in next entityIdentifier
 auditModelDetail.entityIdentifier=entityIdentifier;
 auditModelDetail.entityName=entityName;
 auditModelDetail.fromService=fromService;

 auditModelDetail.operationDate= this.datepipe.transform(new Date(),this._dateformart.PayloadDateTime); //new Date();

 auditModelDetail.entityCreatedDate= this.datepipe.transform(new Date(),this._dateformart.PayloadDateTime); //new Date();
 auditModelDetail.entityModifiedDate= this.datepipe.transform(new Date(),this._dateformart.PayloadDateTime); //new Date();

let operatorName=this.privilegeService.getUserName(this.privilegeService.getLoginUserId());
let ipAddress='';
let country='';
try{
  ipAddress=await this.getIPAddress();
  country = await this.geoCountryService.resolveCountry(ipAddress);
}catch(error){
  console.error('Unable to resolve client IP address for audit log', error);
}

auditModelDetail.operatorUsername = `${operatorName} | IP: ${ipAddress}| Location: ${country}`;
auditModelDetail.entityCreatedByName = (operationType === this.auditOperations.Create || operationType === this.auditOperations.Delete)
  ? `${operatorName} | IP: ${ipAddress}| Location: ${country}`
  : operatorName;
auditModelDetail.entityModifiedByName = (operationType === this.auditOperations.Update || operationType === this.auditOperations.Delete)
  ? `${operatorName} | IP: ${ipAddress} | Contry:${country}| Location: ${country}`
  : operatorName;


 auditModelDetail.fieldModifications=listOfAuditLogModel;

//Call save Audit api here 
console.log(auditModelDetail);
this.PostAuditDetails(auditModelDetail).subscribe(
  data => {
    var response = data.data;
  }
);

 }
}

private async logAction(operationType: string, entityName: string, entityIdentifier: string, fromService: string, changedFieldName: string, changedFieldValue: string): Promise<void> {
  return this.logActionFields(operationType, entityName, entityIdentifier, fromService, [this.buildFieldChange(changedFieldName, changedFieldValue)]);
}

private buildFieldChange(fieldName: string, value: any): FieldChangeForAuditModel {
  var fieldChange = new FieldChangeForAuditModel();
  fieldChange.fieldName = fieldName;
  fieldChange.oldValue = '';
  fieldChange.newValue = (value === null || value === undefined || value === '') ? 'Not Selected' : String(value);
  return fieldChange;
}

private async logActionFields(operationType: string, entityName: string, entityIdentifier: string, fromService: string, fieldModifications: FieldChangeForAuditModel[]): Promise<void> {
  try {
  this._dateformart = Dateformat;
  var auditModelDetail = new AuditLogModel();

  auditModelDetail.operationType = operationType;
  auditModelDetail.entityIdentifier = entityIdentifier;
  auditModelDetail.entityName = entityName;
  auditModelDetail.fromService = fromService;

  auditModelDetail.operationDate = this.datepipe.transform(new Date(), this._dateformart.PayloadDateTime);
  auditModelDetail.entityCreatedDate = this.datepipe.transform(new Date(), this._dateformart.PayloadDateTime);
  auditModelDetail.entityModifiedDate = this.datepipe.transform(new Date(), this._dateformart.PayloadDateTime);

  let operatorName = this.privilegeService.getUserName(this.privilegeService.getLoginUserId());
  let ipAddress = '';
 let country = '';
  try {
    ipAddress = await this.getIPAddress();
    country = await this.geoCountryService.resolveCountry(ipAddress);
  } catch (error) {
    console.error('Unable to resolve client IP address for audit log', error);
  }

  auditModelDetail.operatorUsername = `${operatorName} | IP: ${ipAddress}| Location: ${country}`;
  auditModelDetail.entityCreatedByName = `${operatorName} | IP: ${ipAddress}| Location: ${country}`;
  auditModelDetail.entityModifiedByName = operatorName;

  auditModelDetail.fieldModifications = fieldModifications;

  await firstValueFrom(this.PostAuditDetails(auditModelDetail));
  } catch (error) {
    console.error(`Failed to log ${operationType} audit for ` + entityName, error);
  }
}

public async logView(entityName: string, entityIdentifier: string, fromService: string): Promise<void> {
  return this.logAction(AuditOperations.View, entityName, entityIdentifier, fromService, 'Screen', entityName);
}

public async logViewWithFilters(entityName: string, entityIdentifier: string, fromService: string, filters: { [fieldName: string]: any }): Promise<void> {
  var fieldModifications = [this.buildFieldChange('Screen', entityName)];
  Object.keys(filters).forEach(fieldName => {
    fieldModifications.push(this.buildFieldChange(fieldName, filters[fieldName]));
  });
  return this.logActionFields(AuditOperations.View, entityName, entityIdentifier, fromService, fieldModifications);
}

public async logDownload(entityName: string, entityIdentifier: string, fromService: string, fileName: string): Promise<void> {
  return this.logAction(AuditOperations.Download, entityName, entityIdentifier, fromService, 'File', fileName);
}

// Records a Download with the file plus the record it came from, so the audit shows which meeting,
// invoice or projection the attachment belonged to and not just the file name.
public async logDownloadWithFilters(entityName: string, entityIdentifier: string, fromService: string, fileName: string, filters: { [fieldName: string]: any }): Promise<void> {
  var fieldModifications = [this.buildFieldChange('File', fileName)];
  Object.keys(filters).forEach(fieldName => {
    fieldModifications.push(this.buildFieldChange(fieldName, filters[fieldName]));
  });
  return this.logActionFields(AuditOperations.Download, entityName, entityIdentifier, fromService, fieldModifications);
}

public async logExport(entityName: string, entityIdentifier: string, fromService: string, fileName: string): Promise<void> {
  return this.logAction(AuditOperations.Export, entityName, entityIdentifier, fromService, 'File', fileName);
}

// Records an Export with the file plus the record the list belongs to, so the audit shows which
// contract or engagement the exported rows came from.
public async logExportWithFilters(entityName: string, entityIdentifier: string, fromService: string, fileName: string, filters: { [fieldName: string]: any }): Promise<void> {
  var fieldModifications = [this.buildFieldChange('File', fileName)];
  Object.keys(filters).forEach(fieldName => {
    fieldModifications.push(this.buildFieldChange(fieldName, filters[fieldName]));
  });
  return this.logActionFields(AuditOperations.Export, entityName, entityIdentifier, fromService, fieldModifications);
}

private getAuthToken(): string {
  return this.authService.getCookieValue('LOGIN_TOKEN') || localStorage.getItem('token') || '';
}

public PostAuditDetails(model:any){
  var token=this.getAuthToken();
  var httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json',"Authorization": "Bearer "+token}) };

  //var url='https://csapidev.freyrkontractpro.com/audit/system/audit-log';
  var url = this._auditApiBaseURl+"system/audit-log";

  return this.http.post<any>(url, model,httpOptions);
}


public GetAuditDetailById(auditId: string | number): Observable<any> {

  var token=this.getAuthToken();
  var httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json',"Authorization": "Bearer "+token}) };

  var url = this._auditApiBaseURl+"log-record/one/modification-info?auditId="+auditId;
  return this.http.get<any>(url,httpOptions);

}

public GetAuditLogList(pageNum: number, pageSize: number, startDate?: string, endDate?: string): Observable<any> {
  var getAuditDetailsPayload: any = {
    "pageSize": pageSize,
    "pageNum": pageNum
  };
  if (startDate) {
    getAuditDetailsPayload.startDate = startDate;
  }
  if (endDate) {
    getAuditDetailsPayload.endDate = endDate;
  }
  var token=this.getAuthToken();
  var httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json',"Authorization": "Bearer "+token}) };

  var url = this._auditApiBaseURl+"log-record/list";

  return this.http.post<any>(url, getAuditDetailsPayload,httpOptions);
}



// public GetAuditLogDetails_Gateway_Get(): Observable<any> {
 
//   var token=this.authService.getCookieValue('LOGIN_TOKEN');
//   var httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json',"Authorization": "Bearer "+token}) };
  
//   var url='https://devapi.freyrkontractpro.com/Api/Gateway/audit/log-record/one/modification-info?auditId=10000029';
 
//   return this.http.get<any>(url,httpOptions);
// }

}
